import React, { useEffect } from 'react'
import { processError } from 'helpers'
import { getAnalyticsContext } from 'analytics'
import { useAcademyCourse } from 'modules/academy'
import { useCartModify } from 'modules/cart'

import OrderProductBase from 'compositions/orderItems/OrderProductBase/OrderProductBase'

import AcademyCoursePrice from './components/AcademyCoursePrice/AcademyCoursePrice'


type AcademyCourseOrderItemProps = {
  className?: string
  data: OrderItems.Product
  withRemoveButton?: boolean
  'data-testid'?: string
}

const AcademyCourseOrderItem: React.FC<AcademyCourseOrderItemProps> = (props) => {
  const { className, data, withRemoveButton, 'data-testid': dataTestId } = props
  const { id, name, brand, image, rebrandImage, quantity, price, productId } = data
  const { data: courseData } = useAcademyCourse({ productId })

  const [ cartModify, { isFetching: isCartModifyFetching } ] = useCartModify()

  useEffect(() => {
    if (quantity > 1) {
      void (async () => {
        try {
          const { page, pageType } = getAnalyticsContext()

          await cartModify({
            productItems: [
              {
                productLineItemId: id,
                quantity: 1,
              },
            ],
            metadata: {
              page,
              pageType,
              placement: 'Cart',
            },
          })
        }
        catch (error) {
          processError(error)
        }
      })()
    }
  }, [ quantity, cartModify, id ])


  const tradingItem = courseData?.product.tradingItems.items[0]

  // cart mode
  const priceNode = tradingItem && !isCartModifyFetching ? (
    <div className="text-right">
      <AcademyCoursePrice price={price} prices={tradingItem.prices} isCart={withRemoveButton} />
    </div>
  ) : undefined

  return (
    <OrderProductBase
      className={className}
      image={image}
      rebrandImage={rebrandImage}
      name={name}
      brand={brand}
      quantity={quantity}
      priceNode={priceNode}
      data-testid={dataTestId}
    />
  )
}

export default AcademyCourseOrderItem
